import { State } from "../types/store";

export const selectPages = (state: State) => state.pages.list;
export const selectCurrentPage = (state: State) => state.pages.current;

// export const selectFields = (state: State) =>
//     state.pages.list.filter(page => page.id === state.ui.currentPage)[0]?.fields;

// export const selectLabelsDesigningIsActive = (state: State) => {
//     return state.pages.list[0].fields.every(field => field.label.isDesigning);
// };
